import React, { createContext, useState, useEffect } from 'react';
export const CartContext = createContext();

export const CartProvider = (props) => {
	const [cartData, setCartData] = useState([]);
	const [toggleCart, setToggleCart] = useState(false);
	const [cartError, setCartError] = useState(null);
	const [step, setStep] = useState(0);
	const [couponCode, setCouponCode] = useState('');
	const [velocityNumber, setVelocityNumber] = useState(null);
	const [velocityNumberError, setVelocityNumberError] = useState(false);
	const [guestShipping, setGuestShipping] = useState(false);
	const [voucherPopupEmail, setVoucherPopupEmail] = useState('');

	useEffect(() => {
		addtoCart();
	}, []);

	const addtoCart = (item, doNotOpenCart = false) => {
		if (item) {
			setCartData([{ ...item, quantity: 1 }]);

			if (!doNotOpenCart) {
				handleToggleCart();
			}
		}
	};

	const removeFromCart = (itemCode) => {
		if (itemCode) {
			const remainingItems = cartData.filter(
				(cartItem) => cartItem.itemCode !== itemCode
			);
			setCartData(remainingItems);
		}
	};

	const addCouponCode = (code) => {
		if (code) {
			setCouponCode(code);
		}
	};

	const removeCouponCode = () => {
		setCouponCode('');
	};

	const addVelocityNumber = (code) => {
		if (code) {
			setVelocityNumber(code);
		}
	};

	const removeVelocityNumber = () => {
		setVelocityNumber('');
	};

	const handleToggleCart = () => {
		setToggleCart(!toggleCart);
		if (sessionStorage.getItem('orderDetails')) {
			setTimeout(() => {
				setCartData([]);
				setStep(0);
				sessionStorage.removeItem('orderDetails');
			}, 500);
		}
	};

	return (
		<CartContext.Provider
			value={{
				cartData,
				addtoCart,
				cartError,
				handleToggleCart,
				toggleCart,
				setToggleCart,
				removeFromCart,
				step,
				setStep,
				addCouponCode,
				removeCouponCode,
				couponCode,
				addVelocityNumber,
				removeVelocityNumber,
				velocityNumber,
				setVelocityNumberError,
				velocityNumberError,
				guestShipping,
				setGuestShipping,
				voucherPopupEmail,
				setVoucherPopupEmail,
			}}
		>
			{props.children}
		</CartContext.Provider>
	);
};
